import { alpha, type Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material/styles';

/** Celeste crema — tonos de hover/selección (escala ~83 / 183 / 283) */
const TABLE_ROW_HOVER = {
  light: '#d8fafe', // ~83
  lightSelected: '#b6e8fc', // ~183
  lightSelectedHover: '#9cf1fb', // ~283
  darkBase: '#22d3ee',
} as const;

/** Fuente única del hover/selección en tablas, dropdowns y listas seleccionables. */
export function getTableRowHoverOverlay(theme: Theme): string {
  return theme.palette.mode === 'dark'
    ? alpha(TABLE_ROW_HOVER.darkBase, 0.155)
    : TABLE_ROW_HOVER.light;
}

/** Alias semántico — mismo token para tablas y dropdowns. */
export const getSelectableRowHoverOverlay = getTableRowHoverOverlay;

export function getTableRowSelectedOverlay(theme: Theme): string {
  return theme.palette.mode === 'dark'
    ? alpha(TABLE_ROW_HOVER.darkBase, 0.215)
    : TABLE_ROW_HOVER.lightSelected;
}

export function getTableRowSelectedHoverOverlay(theme: Theme): string {
  return theme.palette.mode === 'dark'
    ? alpha(TABLE_ROW_HOVER.darkBase, 0.265)
    : TABLE_ROW_HOVER.lightSelectedHover;
}

/** Hover estándar para ítems de lista/dropdown (sx inline). */
export const selectableListItemHoverSx: SxProps<Theme> = (theme) => ({
  '&:hover': {
    backgroundColor: getTableRowHoverOverlay(theme),
  },
});

/** Filas seleccionables sin fondo de selección persistente (solo hover). */
export const tableRowTransparentSelectionSx: SxProps<Theme> = (theme) => {
  const hover = `${getTableRowHoverOverlay(theme)} !important`;
  return {
    '&.Mui-selected': {
      backgroundColor: 'transparent !important',
      background: 'transparent !important',
    },
    '&.Mui-selected:hover': {
      backgroundColor: hover,
      background: hover,
    },
  };
};
